function isChartValue(value) {
  if (typeof value !== 'number' && typeof value !== 'string') return false
  const numericValue = Number(value)
  return Number.isFinite(numericValue) && numericValue !== 0
}

export function hasChartData(items, key) {
  return (items || []).some(item => isChartValue(key ? item?.[key] : item))
}
